import { Flex, Icon, ProductColor, Tooltip, Typography } from '@aloft/toolkit-sui';
import { Spinner } from '@aloft/toolkit-sui/chakra';

export type AnalysisLabelProps = {
  state: 'loading' | 'error' | 'success';
  tooltip: string;
  recommend?: string;
  color?: ProductColor;
};

export function AnalysisLabel({ state, tooltip, recommend, color }: AnalysisLabelProps) {
  return (
    <Tooltip label={tooltip}>
      <Flex flexDirection="row" gap={1} alignItems="center">
        <Icon icon="sparkle" size="sm" color={color} />
        {state === 'loading' && <Spinner size="xs" />}
        {state === 'error' && <Icon icon="error-warning" size="sm" color={color} />}
        {state === 'success' && (
          <Typography inline variant="body2" color={color}>
            {recommend ?? '-'}
          </Typography>
        )}
      </Flex>
    </Tooltip>
  );
}
